import { localizedGeoCheckStatus } from "../../intl/shared-resources/geoCheckStatus.js";
import { ChipVariant, ChipType } from "../../components/chip/types.js";
import { GeoCheckStatus } from "../../contract/pam.js";
const getGeoCheckStatusChipsMapping = () => ({
  [GeoCheckStatus.Success]: {
    label: localizedGeoCheckStatus[GeoCheckStatus.Success],
    chipType: ChipType.Status,
    chipVariant: ChipVariant.Green
  },
  [GeoCheckStatus.Failed]: {
    label: localizedGeoCheckStatus[GeoCheckStatus.Failed],
    chipType: ChipType.Status,
    chipVariant: ChipVariant.Disabled
  }
});
export {
  getGeoCheckStatusChipsMapping
};
//# sourceMappingURL=geoCheckStatusChipConfig.js.map
